// p0-security-nov2: mirrors backend/password_policy.py so users see the rule
// before submitting. The backend is the source of truth (it returns the same
// messages in `detail`). Only used when a NEW password is chosen (sign-up,
// reset, change); never on login.
export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 128;

const COMMON_PASSWORDS = new Set([
  "123456", "123456789", "12345678", "password", "qwerty123", "qwerty1",
  "111111", "12345", "secret", "123123", "1234567890", "1234567",
  "000000", "qwerty", "abc123", "password1", "iloveyou", "11111111",
  "dragon", "monkey",
]);

export const PASSWORD_HINT = `At least ${MIN_PASSWORD_LENGTH} characters. Avoid common passwords like "12345678".`;

export function passwordProblem(password) {
  const pwd = typeof password === "string" ? password : "";
  if (pwd.length < MIN_PASSWORD_LENGTH) return `Password must be at least ${MIN_PASSWORD_LENGTH} characters long.`;
  if (pwd.length > MAX_PASSWORD_LENGTH) return `Password must be at most ${MAX_PASSWORD_LENGTH} characters long.`;
  if (COMMON_PASSWORDS.has(pwd.trim().toLowerCase())) return "That password is too common. Please choose a less guessable password.";
  return null;
}

// FastAPI `detail` can be a string, a list of validation errors, or an object.
export function apiErrorMessage(err, fallback = "Failed") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (Array.isArray(detail) && detail.length) {
    const first = detail[0];
    if (typeof first === "string") return first;
    if (first && typeof first.msg === "string") return first.msg;
  }
  if (detail && typeof detail === "object" && Array.isArray(detail.errors) && detail.errors.length) {
    return String(detail.errors[0]);
  }
  return err?.message || fallback;
}
